
import React from 'react'
import Breadcrumb from '../../Shared/BreadCumb';
import { getAllPenalities } from './services/penalities';
import ClipLoader from "react-spinners/ClipLoader";
import { MagnifyingGlassIcon} from '@heroicons/react/20/solid';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import ResponsiveTable from '../../Shared/ResponsiveTable';
 
class DetailPenalitie extends React.Component {
    people = []

    columns = [
        {field:'numberPlate', headerName: 'Placa'},
    ]

    constructor(props) {
        super(props);
        this.state = {
            item: null,
            loading: false,
            tabs: [
                { name: 'Detalles del Usuario', href: '#', current: true, id:0 },
                { name: 'Historial de Vehículos', href: '#', current: false, id:1 },
                { name: 'Historial de Multas', href: '#', current: false, id:2 },
            ],
            detailDialog:false,
            detailPenalitie:null,
            updatePenalitie:true
        }
    }

    classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    setTab = (tab) => {
        const tabs = this.state.tabs.map((t)=>{
                if(t.id === tab.id){
                    t.current = true
                }else{
                    t.current = false
                }
                return t
            });
        this.setState({tabs:tabs});
    }

    componentDidMount = () => {
        const id = window.location.href.split('/')[window.location.href.split('/').length-1]
        this.setState({loading:true})
        getAllPenalities({limit:1000, identification:id, status:-1 })
            .then((result) => {
                if(result && result.status === 200) {
                    this.setState({item:result.data.data[0], loading:false})
                }else{
                    this.setState({loading:false})
                }  
            }).catch((error) => console.log(error))
    }

    BreadcrumbPages = [
        { name: 'Administración', href: '', current: false },
        { name: 'Lista de Multas', href: '', current: false },
        { name: 'Detalles', href: '', current: true },
    ]

    formatDate = (date) => {
        const fecha = new Date(date);
        const horas = fecha.getHours();
        const minutos = fecha.getMinutes();
        const ampm = horas >= 12 ? 'PM' : 'AM';
        const horaFormateada = horas % 12 || 12; // Ajusta para que 0 horas sea 12 AM

        // Formatear la fecha y hora como deseas
        return `${fecha.getFullYear()}-${(fecha.getMonth() + 1).toString().padStart(2, '0')}-${fecha.getDate()} ${horaFormateada}:${minutos.toString().padStart(2, '0')} ${ampm}`;
    }

    renderUserDetail = () => {
        return(
            <div className="space-y-6">
                {/* Header Card */}
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 border border-blue-200">
                    <div className="flex items-center">
                        <div className="flex-shrink-0">
                            <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                </svg>
                            </div>
                        </div>
                        <div className="ml-4">
                            <h3 className="text-xl font-bold text-gray-900">
                                {this.state.item.firstName} {this.state.item.middleName} {this.state.item.firstLastName} {this.state.item.middleLastName}
                            </h3>
                            <p className="text-blue-600 font-medium">ID: {this.state.item.identification}</p>
                        </div>
                    </div>
                </div>

                {/* Details Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Personal Information */}
                    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                        <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                            <svg className="w-5 h-5 text-gray-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Información Personal
                        </h4>
                        <div className="space-y-4">
                            <div className="bg-gray-50 p-3 rounded-lg">
                                <dt className="text-sm font-medium text-gray-600 mb-1">Nombre Completo</dt>
                                <dd className="text-sm font-semibold text-gray-900">
                                    {this.state.item.firstName} {this.state.item.middleName} {this.state.item.firstLastName} {this.state.item.middleLastName}
                                </dd>
                            </div>
                            <div className="bg-gray-50 p-3 rounded-lg">
                                <dt className="text-sm font-medium text-gray-600 mb-1">Identificación</dt>
                                <dd className="text-sm font-semibold text-gray-900">{this.state.item.identification}</dd>
                            </div>
                            <div className="bg-gray-50 p-3 rounded-lg">
                                <dt className="text-sm font-medium text-gray-600 mb-1">Género</dt>
                                <dd className="text-sm font-semibold text-gray-900">{this.state.item.gender || 'No especificado'}</dd>
                            </div>
                        </div>
                    </div>

                    {/* Contact Information */}
                    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                        <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                            <svg className="w-5 h-5 text-gray-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            Información de Contacto
                        </h4>
                        <div className="space-y-4">
                            <div className="bg-gray-50 p-3 rounded-lg">
                                <dt className="text-sm font-medium text-gray-600 mb-1">Correo Electrónico</dt>
                                <dd className="text-sm font-semibold text-gray-900 break-all">{this.state.item.email || 'No registrado'}</dd>
                            </div>
                            <div className="bg-gray-50 p-3 rounded-lg">
                                <dt className="text-sm font-medium text-gray-600 mb-1">Dirección</dt>
                                <dd className="text-sm font-semibold text-gray-900">{this.state.item.address || 'No registrada'}</dd>
                            </div>
                            <div className="bg-gray-50 p-3 rounded-lg">
                                <dt className="text-sm font-medium text-gray-600 mb-1">Teléfonos</dt>
                                <dd className="flex flex-wrap gap-2 mt-1">
                                    {this.state.item.phone?.length > 0 ? 
                                        this.state.item.phone.map((phone, idx) => (
                                            <span key={idx} className="inline-flex items-center rounded-full bg-blue-100 px-3 py-1 text-xs font-medium text-blue-800 border border-blue-200">
                                                {phone}
                                            </span>
                                        )) :
                                        <span className="text-sm text-gray-500">No registrados</span>
                                    }
                                </dd>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderVehicle() {
        return (
            <div className="space-y-6">
                {/* Header */}
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-6 border border-green-200">
                    <div className="flex items-center">
                        <div className="flex-shrink-0">
                            <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center">
                                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                        </div>
                        <div className="ml-4">
                            <h3 className="text-xl font-bold text-gray-900">Vehículos Registrados</h3>
                            <p className="text-green-600 font-medium">{this.state.item.vehicle?.length || 0} vehículo(s) encontrado(s)</p>
                        </div>
                    </div>
                </div>

                {/* Vehicles Grid */}
                {this.state.item.vehicle?.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {this.state.item.vehicle.map((vehicle, index) => (
                            <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow duration-200">
                                <div className="flex items-center justify-between mb-4">
                                    <div className="flex items-center">
                                        <span className="ml-3 text-lg font-bold text-gray-900">{vehicle.numberPlate}</span>
                                    </div>
                                </div>
                                
                                <div className="space-y-3">
                                    <div className="bg-gray-50 p-3 rounded-lg">
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm font-medium text-gray-600">Marca</span>
                                            <span className="text-sm font-semibold text-gray-900">{vehicle.brand || 'No especificada'}</span>
                                        </div>
                                    </div>
                                    
                                    <div className="bg-gray-50 p-3 rounded-lg">
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm font-medium text-gray-600">Color</span>
                                            <span className="text-sm font-semibold text-gray-900">{vehicle.color || 'No especificado'}</span>
                                        </div>
                                    </div>
                                    
                                    <div className="bg-gray-50 p-3 rounded-lg">
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm font-medium text-gray-600">Año</span>
                                            <span className="text-sm font-semibold text-gray-900">{vehicle.nYear || 'No especificado'}</span>
                                        </div>
                                    </div>
                                    
                                    <div className="bg-gray-50 p-3 rounded-lg">
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm font-medium text-gray-600">Serial</span>
                                            <span className="text-sm font-semibold text-gray-900 break-all">{vehicle.serial || 'No especificado'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-12 bg-white rounded-xl border border-gray-200">
                        <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                        <h3 className="mt-2 text-sm font-medium text-gray-900">Sin vehículos registrados</h3>
                        <p className="mt-1 text-sm text-gray-500">No se encontraron vehículos asociados a esta persona.</p>
                    </div>
                )}
            </div>
        )
    }

    
    renderInfractionDetail(){
        return(
            <div className="space-y-6">
                {/* Header */}
                <div className="bg-gradient-to-r from-red-50 to-pink-50 rounded-xl p-6 border border-red-200">
                    <div className="flex items-center">
                        <div className="flex-shrink-0">
                            <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                </svg>
                            </div>
                        </div>
                        <div className="ml-4">
                            <h3 className="text-xl font-bold text-gray-900">Historial de Multas</h3>
                            <p className="text-red-600 font-medium">{this.state.item.headerFine?.length || 0} multa(s) registrada(s)</p>
                        </div>
                    </div>
                </div>

                {/* Fines Grid */}
                {this.state.item.headerFine?.length > 0 ? (
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        {this.state.item.headerFine.map((penalitie, index) => (
                            <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow duration-200">
                                {/* Header de la multa */}
                                <div className="flex items-center justify-between mb-4">
                                    <div className="flex items-center">
                                        <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                                            <svg className="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                            </svg>
                                        </div>
                                        <div className="ml-3">
                                            <h4 className="text-lg font-bold text-gray-900">{penalitie.typeFineDescrip}</h4>
                                            <p className="text-sm text-gray-500">{this.formatDate(penalitie.dateReg)}</p>
                                        </div>
                                    </div>
                                    <button 
                                        onClick={()=>{this.setState({detailDialog:true,detailPenalitie:penalitie})}}
                                        type="button"
                                        className="rounded-full bg-indigo-950 p-2 text-white shadow-sm hover:bg-indigo-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition-colors duration-200">
                                            <MagnifyingGlassIcon aria-hidden="true" className="h-5 w-5" />
                                    </button>
                                </div>

                                {/* Estado */}
                                <div className="mb-4">
                                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                                        penalitie.descripStatus === 'PENDIENTE' || penalitie.descripStatus === 'PENDIENTE POR PAGAR' ? 
                                            'bg-red-100 text-red-800 border border-red-200' :
                                        penalitie.descripStatus === 'PAGADA' ?
                                            'bg-green-100 text-green-800 border border-green-200' :
                                        penalitie.descripStatus === 'PAGO PARCIAL' ?
                                            'bg-yellow-100 text-yellow-800 border border-yellow-200' :
                                            'bg-gray-100 text-gray-800 border border-gray-200'
                                    }`}>
                                        {penalitie.descripStatus}
                                    </span>
                                </div>

                                {/* Detalles */}
                                <div className="space-y-3">
                                    <div className="bg-gray-50 p-3 rounded-lg">
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm font-medium text-gray-600">Valor Total</span>
                                            <span className="text-sm font-bold text-green-600">{penalitie.totalValue}</span>
                                        </div>
                                    </div>
                                    
                                    <div className="bg-gray-50 p-3 rounded-lg">
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm font-medium text-gray-600">Factor</span>
                                            <span className="text-sm font-semibold text-gray-900">{penalitie.factor}</span>
                                        </div>
                                    </div>
                                    
                                    <div className="bg-gray-50 p-3 rounded-lg">
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm font-medium text-gray-600">Placa del Vehículo</span>
                                            <span className="text-sm font-semibold text-gray-900">{penalitie.numberPlate || 'No especificada'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-12 bg-white rounded-xl border border-gray-200">
                        <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <h3 className="mt-2 text-sm font-medium text-gray-900">Sin multas registradas</h3>
                        <p className="mt-1 text-sm text-gray-500">No se encontraron multas asociadas a esta persona.</p>
                    </div>
                )}
            </div>
        )
    }


    dialogDetail() {
            return(
                <Dialog open={this.state.detailDialog} onClose={()=>{console.log("closed")}} className="relative z-50">
                    <DialogBackdrop
                        transition
                        className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in z-40"
                    />

                <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden rounded-2xl bg-white shadow-2xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in w-full max-w-4xl h-[calc(100vh-2rem)] data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 flex flex-col"
                    >
                        <div className="bg-white flex flex-col h-full">
                            {/* Header */}
                            <div className="bg-gray-50 border-b border-gray-200 px-6 py-4 flex-shrink-0">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center">
                                        <MagnifyingGlassIcon className="h-6 w-6 text-gray-600 mr-3" />
                                        <div>
                                            <h3 className="text-lg font-semibold text-gray-900">Detalles de la Multa</h3>
                                            <p className="text-sm text-gray-500">{this.state.detailPenalitie?.typeFineDescrip}</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center space-x-3">
                                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                                            this.state.detailPenalitie?.descripStatus === 'PENDIENTE POR PAGAR' ? 'bg-red-100 text-red-800' :
                                            this.state.detailPenalitie?.descripStatus === 'PAGO PARCIAL' ? 'bg-yellow-100 text-yellow-800' :
                                            this.state.detailPenalitie?.descripStatus === 'PAGADA' ? 'bg-green-100 text-green-800' :
                                            this.state.detailPenalitie?.descripStatus === 'MOROSA' ? 'bg-orange-100 text-orange-800' :
                                            'bg-gray-100 text-gray-800'
                                        }`}>
                                            {this.state.detailPenalitie?.descripStatus}
                                        </span>
                                        <button
                                            onClick={() => {this.setState({detailDialog:false})}}
                                            className="rounded-full p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors duration-200"
                                            aria-label="Cerrar"
                                        >
                                            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Content */}
                            <div className="flex-1 overflow-y-auto p-6">
                                <div className="space-y-6">
                                    {/* Información básica de la multa */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                            <p className="text-sm text-blue-600 mb-1">Número de Multa</p>
                                            <p className="font-semibold text-blue-900 text-lg">
                                                {this.state.detailPenalitie?.code || 'No especificado'}
                                            </p>
                                        </div>
                                        <div className="bg-gray-50 p-4 rounded-lg">
                                            <p className="text-sm text-gray-600 mb-1">Fecha</p>
                                            <p className="font-semibold text-gray-900">
                                                {this.formatDate(this.state.detailPenalitie?.dateReg)}
                                            </p>
                                        </div>
                                        <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                                            <p className="text-sm text-green-600 mb-1">Monto Total</p>
                                            <p className="font-semibold text-green-900 text-xl">
                                                Bs. {this.state.detailPenalitie?.totalValue}
                                            </p>
                                        </div>
                                        <div className="bg-gray-50 p-4 rounded-lg">
                                            <p className="text-sm text-gray-600 mb-1">Factor</p>
                                            <p className="font-semibold text-gray-900">
                                                {this.state.detailPenalitie?.factor}
                                            </p>
                                        </div>
                                        <div className="bg-gray-50 p-4 rounded-lg">
                                            <p className="text-sm text-gray-600 mb-1">Sector</p>
                                            <p className="font-semibold text-gray-900">
                                                {this.state.detailPenalitie?.sectorDescrip || 'No especificado'}
                                            </p>
                                        </div>
                                        <div className="bg-gray-50 p-4 rounded-lg">
                                            <p className="text-sm text-gray-600 mb-1">Tipo de Infracción</p>
                                            <p className="font-semibold text-gray-900">
                                                {this.state.detailPenalitie?.subTypeDescrip || 'No especificado'}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Información del vehículo */}
                                    {(this.state.detailPenalitie?.numberPlate || this.state.detailPenalitie?.brand || this.state.detailPenalitie?.model) && (
                                        <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                            <p className="text-sm text-blue-950 mb-3 font-medium">Información del Vehículo</p>
                                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                                {this.state.detailPenalitie?.numberPlate && (
                                                    <div className="bg-white p-3 rounded-lg">
                                                        <p className="text-sm text-gray-600 mb-1">Placa</p>
                                                        <p className="font-semibold text-gray-900">{this.state.detailPenalitie.numberPlate}</p>
                                                    </div>
                                                )}
                                                {this.state.detailPenalitie?.brand && (
                                                    <div className="bg-white p-3 rounded-lg">
                                                        <p className="text-sm text-gray-600 mb-1">Marca</p>
                                                        <p className="font-semibold text-gray-900">{this.state.detailPenalitie.brand}</p>
                                                    </div>
                                                )}
                                                {this.state.detailPenalitie?.model && (
                                                    <div className="bg-white p-3 rounded-lg">
                                                        <p className="text-sm text-gray-600 mb-1">Modelo</p>
                                                        <p className="font-semibold text-gray-900">{this.state.detailPenalitie.model}</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {/* Información del oficial */}
                                    {(this.state.detailPenalitie?.officialFirstName || this.state.detailPenalitie?.officialIdentification) && (
                                        <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                            <p className="text-sm text-blue-950 mb-3 font-medium">Oficial Responsable</p>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                {(this.state.detailPenalitie?.officialFirstName || this.state.detailPenalitie?.officialFirstLastName) && (
                                                    <div className="bg-white p-3 rounded-lg">
                                                        <p className="text-sm text-gray-600 mb-1">Nombre</p>
                                                        <p className="font-semibold text-gray-900">
                                                            {this.state.detailPenalitie?.officialFirstName} {this.state.detailPenalitie?.officialFirstLastName}
                                                        </p>
                                                    </div>
                                                )}
                                                {this.state.detailPenalitie?.officialIdentification && (
                                                    <div className="bg-white p-3 rounded-lg">
                                                        <p className="text-sm text-gray-600 mb-1">Cédula</p>
                                                        <p className="font-semibold text-gray-900">{this.state.detailPenalitie?.officialIdentification}</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {/* Descripción/Comentario */}
                                    {this.state.detailPenalitie?.comment && (
                                        <div className="bg-gray-50 p-4 rounded-lg">
                                            <p className="text-sm font-medium text-gray-700 mb-3">Descripción</p>
                                            <p className="text-gray-900 text-justify leading-relaxed">
                                                {this.state.detailPenalitie?.comment}
                                            </p>
                                        </div>
                                    )}

                                    {/* Conceptos de la multa */}
                                    {this.state.detailPenalitie?.detailFine && this.state.detailPenalitie.detailFine.length > 0 && (
                                        <div className="bg-amber-50 p-4 rounded-lg border border-amber-200">
                                            <p className="text-sm font-medium text-amber-700 mb-3">Conceptos de la Multa</p>
                                            <div className="space-y-3">
                                                {this.state.detailPenalitie.detailFine.map((item, index) => (
                                                    <div key={index} className="bg-white p-3 rounded-lg border border-amber-200">
                                                        <p className="font-medium text-gray-900 mb-1">• {item.concept}</p>
                                                        <p className="text-sm text-amber-700">
                                                            Valor: <span className="font-semibold"> {item.valueFine}</span>
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Evidencia fotográfica */}
                                    <div className="bg-gray-50 p-4 rounded-lg">
                                        <p className="text-sm font-medium text-gray-700 mb-3">Evidencia Fotográfica</p>
                                        {this.state.detailPenalitie?.image && this.state.detailPenalitie.image.length > 0 ? (
                                            <div className="flex justify-center">
                                                <img 
                                                    src={this.state.detailPenalitie.image[0].url} 
                                                    className="max-h-80 w-auto object-cover rounded-lg border border-gray-300 shadow-sm" 
                                                    alt='Foto de la infracción'
                                                />
                                            </div>
                                        ) : (
                                            <div className="text-center py-8 text-gray-500">
                                                <svg className="h-12 w-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                </svg>
                                                <p>No posee evidencia fotográfica</p>
                                            </div>
                                        )}
                                    </div>

                                    {/* Historial de pagos */}
                                    {this.state.detailPenalitie?.detailFine && this.state.detailPenalitie.detailFine[0] && this.state.detailPenalitie.detailFine[0].paymentDetail ? (
                                        <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                                            <div className="flex items-center mb-3">
                                                <svg className="h-5 w-5 text-green-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                                                </svg>
                                                <p className="text-sm font-medium text-green-700">Historial de Pagos</p>
                                            </div>
                                            <div className="space-y-3">
                                                {this.state.detailPenalitie.detailFine[0].paymentDetail.map((payment, index) => (
                                                    <div key={index} className="bg-white p-4 rounded-lg border border-green-200 shadow-sm">
                                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                                            <div className="flex justify-between items-center">
                                                                <span className="text-sm text-gray-600">Fecha:</span>
                                                                <span className="font-semibold text-gray-900">
                                                                    {this.formatDate(payment.dateReg)}
                                                                </span>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <span className="text-sm text-gray-600">Monto:</span>
                                                                <span className="font-semibold text-green-700 text-lg">
                                                                    Bs. {payment.originalAmount}
                                                                </span>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <span className="text-sm text-gray-600">Tipo de Pago:</span>
                                                                <span className="font-semibold text-gray-900">
                                                                    {payment.paymentTypeDescrip}
                                                                </span>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <span className="text-sm text-gray-600">Banco:</span>
                                                                <span className="font-semibold text-gray-900">
                                                                    {payment.bank}
                                                                </span>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <span className="text-sm text-gray-600">Banco Receptor:</span>
                                                                <span className="font-semibold text-gray-900">
                                                                    {payment.bankReceiving ? payment.bankReceiving : 'No aplica'}
                                                                </span>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <span className="text-sm text-gray-600">Referencia:</span>
                                                                <span className="font-semibold text-gray-900">
                                                                    {payment.reference}
                                                                </span>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <span className="text-sm text-gray-600">Procesado en:</span>
                                                                <span className="font-semibold text-gray-900">
                                                                    {payment.paymentFromDescrip}
                                                                </span>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <span className="text-sm text-gray-600">Usuario:</span>
                                                                <span className="font-semibold text-gray-900">
                                                                    {payment.userName}
                                                                </span>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <span className="text-sm text-gray-600">Titular del pago:</span>
                                                                <span className="font-semibold text-gray-900">
                                                                    {payment.name}
                                                                </span>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <span className="text-sm text-gray-600">Identificación:</span>
                                                                <span className="font-semibold text-gray-900">
                                                                    {payment.identification}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                            <div className="text-center py-8 text-gray-500">
                                                <svg className="h-12 w-12 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                                                </svg>
                                                <p className="text-gray-600 text-lg font-medium mb-2">Sin Pagos Registrados</p>
                                                <p className="text-gray-500 text-sm">
                                                    No existen pagos registrados para esta multa.
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Footer */}
                            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex-shrink-0">
                                <div className="flex justify-end">
                                    <button
                                        type="button"
                                        onClick={() => {this.setState({detailDialog:false})}}
                                        className="inline-flex items-center px-4 py-2 bg-indigo-950 text-white text-sm font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
                                    >
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </DialogPanel>
                    </div>
                </div>
                </Dialog>
            )
    }

    dialogUpdateStatus(){
        return(
                <Dialog open={this.state.updatePenalitie} onClose={()=>{console.log("closed")}} className="relative z-10">
                    <DialogBackdrop
                        transition
                        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                    />

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                        >
                            <div className="sm:flex sm:items-start">
                                
                            </div>
                            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                <button
                                    type="button"
                                    data-autofocus
                                    onClick={() => {this.setState({detailDialog:false})}}
                                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:ml-3 sm:mt-0 sm:w-auto"
                                >
                                    Volver
                                </button>
                            </div>
                        </DialogPanel>
                        </div>
                    </div>
                </Dialog>
            )
    }

    renderDetail(){
        return(
            <div className="space-y-8">
                {/* Header Principal */}
                {this.state.item && (
                    <div className="bg-gradient-to-r from-indigo-950 to-indigo-950 rounded-2xl p-8 text-white">
                        <div className="flex items-center justify-between">
                            <div>
                                <h1 className="text-3xl font-bold mb-2">
                                    Perfil de {this.state.item.firstName} {this.state.item.firstLastName}
                                </h1>
                                <p className="text-indigo-100 text-lg">
                                    Información completa del usuario y su historial
                                </p>
                            </div>
                            <div className="hidden md:block">
                                <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center">
                                    <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Tabs Navigation */}
                <div className="sm:hidden">
                    <select
                        id="tabs"
                        name="tabs"
                        value={this.state.tabs.find((tab) => tab.current)?.name || ''}
                        onChange={(e) => {
                            const selectedTab = this.state.tabs.find(tab => tab.name === e.target.value);
                            if (selectedTab) {
                                this.setTab(selectedTab);
                            }
                        }}
                        className="block w-full rounded-lg border-gray-300 focus:border-indigo-950 focus:ring-indigo-950 shadow-sm"
                    >
                    {this.state.tabs.map((tab) => (
                        <option key={tab.name} value={tab.name}>{tab.name}</option>
                    ))}
                    </select>
                </div>
                
                <div className="hidden sm:block">
                    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-2">
                        <nav aria-label="Tabs" className="flex flex-wrap gap-2">
                            {this.state.tabs.map((tab) => (
                                <button
                                    onClick={()=>this.setTab(tab)}
                                    key={tab.name}
                                    aria-current={tab.current ? 'page' : undefined}
                                    className={this.classNames(
                                    tab.current
                                        ? 'bg-blue-950 text-white shadow-sm'
                                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100',
                                    'flex-1 min-w-0 px-3 py-3 text-center text-sm font-medium rounded-lg transition-all duration-200',
                                    )}
                                >
                                    <span className="truncate block">{tab.name}</span>
                                </button>
                            ))}
                        </nav>
                    </div>
                </div>

                {/* Content */}
                {this.state.item ? (
                    <div className="min-h-96">
                        {this.state.tabs[0].current && this.renderUserDetail()}
                        {this.state.tabs[1].current && this.renderVehicle()}
                        {this.state.tabs[2].current && this.renderInfractionDetail()}
                        {this.dialogDetail()}
                    </div>
                ) : (
                    <div className="text-center py-16 bg-white rounded-xl border border-gray-200">
                        <svg className="mx-auto h-16 w-16 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">Datos no encontrados</h3>
                        <p className="text-gray-500 max-w-md mx-auto">
                            Tras una revisión de su historial, se confirma que no se han encontrado multas asignadas a esta persona.
                        </p>
                    </div>
                )}
            </div>
        )
    }


    render(){
          return (
            <div className="max-w-7xl mx-auto px-4">
                <Breadcrumb pages={this.BreadcrumbPages}/>
                <div className="pt-5" >
                    {
                        this.state.loading?
                                    <center>
                                        <ClipLoader
                                            color={'gray'}
                                            loading={true}
                                            size={50}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"/>
                                    </center>
                                    :
                                    <div>
                                        {this.renderDetail()}
                                    </div>
                    }

                </div>
            </div> 
        )
    }
}

export default DetailPenalitie;